export const environment = {
  production: false,
  env: 'Testing',
  ApiUrl: 'https://gvhthapitest.clavisco.com/',
  UiUrl: 'https://gvhthtest.clavisco.com/#/',
  KeyReportManager: 142,
  Company: 78,
  RptManager_Url: "https://rptmngapiv2.clavisco.com/"
};
